;(function(){
  try {
    var key = Object.getOwnPropertyNames(window).find(function(k){ return k && String(k).indexOf('untamed_protection_') === 0; });
    if (key && window[key] && window[key].disabled) return;
  } catch (_) {}

  function initHeader() {
    try {
      var toggles = document.querySelectorAll('.mobile-menu-toggle');
      var mobileClose = document.getElementById('mobile-menu-close');
      var mobileDrawer = document.getElementById('mobile-drawer');
      var overlay = document.getElementById('mobile-drawer-overlay');
      if (toggles.length && mobileDrawer && overlay) {
        toggles.forEach(function(btn){
          btn.addEventListener('click', function(){
            mobileDrawer.classList.add('is-active');
            overlay.classList.add('is-active');
            document.body.style.overflow = 'hidden';
            var fixedHeader = document.getElementById('site-header-fixed');
            if (fixedHeader) fixedHeader.style.display = 'none';
            btn.classList.add('active');
          });
        });
        if (mobileClose) {
          mobileClose.addEventListener('click', function(){
            mobileDrawer.classList.remove('is-active');
            overlay.classList.remove('is-active');
            document.body.style.overflow = '';
            var fixedHeader = document.getElementById('site-header-fixed');
            if (fixedHeader && window.scrollY > 0) fixedHeader.style.display = '';
            document.querySelectorAll('.mobile-menu-toggle').forEach(function(b){ b.classList.remove('active'); });
          });
        }
        overlay.addEventListener('click', function(){
          mobileDrawer.classList.remove('is-active');
          overlay.classList.remove('is-active');
          document.body.style.overflow = '';
          var fixedHeader = document.getElementById('site-header-fixed');
          if (fixedHeader && window.scrollY > 0) fixedHeader.style.display = '';
          document.querySelectorAll('.mobile-menu-toggle').forEach(function(b){ b.classList.remove('active'); });
        });
      }

      var mainHeader = document.getElementById('site-header-main');
      if (mainHeader) {
        var stickyType = mainHeader.getAttribute('sticky');
        function updateScrollState(){
          var y = window.scrollY;
          if (y > 10) { mainHeader.classList.add('header--scrolled'); }
          else { mainHeader.classList.remove('header--scrolled'); }
        }
        if (stickyType === 'always') {
          mainHeader.setAttribute('data-sticky-state', 'active');
          window.addEventListener('scroll', updateScrollState, { passive: true });
          updateScrollState();
        } else if (stickyType === 'scroll-up') {
          var lastY = window.scrollY;
          var ticking = false;
          function updateHeader(){
            var y = window.scrollY;
            if (y <= 50) {
              mainHeader.setAttribute('data-sticky-state', 'idle');
            } else if (y < lastY && y > 100) {
              mainHeader.setAttribute('data-sticky-state', 'active');
            } else if (y > lastY) {
              mainHeader.setAttribute('data-sticky-state', 'idle');
            }
            lastY = y;
            ticking = false;
          }
          window.addEventListener('scroll', function(){
            if (!ticking) { requestAnimationFrame(updateHeader); ticking = true; }
          }, { passive: true });
          updateHeader();
        } else if (stickyType === 'never') {
          mainHeader.setAttribute('data-sticky-state', 'idle');
        }
      }

      document.querySelectorAll('.mobile-nav__submenu-toggle').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault();
          var parent = btn.closest('.mobile-nav__item--has-children');
          if (!parent) return;
          parent.classList.toggle('open');
          var expanded = parent.classList.contains('open');
          btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
      });
    } catch (_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }
})();

